import React, { forwardRef } from 'react';
import classnames from 'classnames';

export interface RadioProps {
  testId?: string;
  labelTestId?: string;
  defaultChecked?:  number;
  id: string;
  name: string;
  label?: string;
  value?: string | number;
  size?: 'sm' | 'lg';
  type?: 'primary' | 'secondary' | 'danger' | 'warning' | 'success' | 'info';
  disabled?: boolean;
}

// eslint-disable-next-line react/display-name
const Radio = forwardRef<HTMLInputElement, RadioProps>(
  (
    {
      testId,
      labelTestId,
      id,
      name,
      type = 'primary',
      defaultChecked,
      size = 'lg',
      disabled = false,
      value,
      label,
      ...props
    }: RadioProps,
    ref,
  ) => {
    return (
      <div
        className={classnames('position-relative', { ' d-flex gap-4': label })}
      >
        <input
          ref={ref}
          {...props}
          id={id}
          data-testid={testId}
          type="radio"
          name={name}
          value={value}
          disabled={disabled}
          checked={defaultChecked === value}
          className="checkbox-radio"
        />
        <label
          className={classnames(
            `checkbox-${size}-check`,
            `checkbox-${type}-outline`,
            `checkbox-round-check`,
          )}
          data-testid={labelTestId}
          htmlFor={id}
        />
        {label && (
          <label
            htmlFor={id}
            className="fs-sm fw-semibold lh-sm text-title pointer"
          >
            {label}
          </label>
        )}
      </div>
    );
  },
);
export {Radio};
